import { render, staticRenderFns } from "./signLink.vue?vue&type=template&id=c1231fc8&scoped=true&"
import script from "./signLink.vue?vue&type=script&lang=js&"
export * from "./signLink.vue?vue&type=script&lang=js&"
import style0 from "./signLink.vue?vue&type=style&index=0&id=c1231fc8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1231fc8",
  null
  
)

export default component.exports